/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountInfo,
  AccountTemplates,
  ErrorResponse,
  InternalServerErrorResponse,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse,
  ValidationErrorResponse,
} from '../models/index';
import {
    AccountInfoFromJSON,
    AccountInfoToJSON,
    AccountTemplatesFromJSON,
    AccountTemplatesToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InternalServerErrorResponseFromJSON,
    InternalServerErrorResponseToJSON,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    UnauthorizedErrorResponseFromJSON,
    UnauthorizedErrorResponseToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';

export interface AccountsControllerGetAccountTemplatesRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    id: string;
}

export interface AccountsControllerGetAccountsRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
}

export interface AccountsControllerGetMarketTemplatesRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI {

    /**
     * Deprecated: Use GET /accounts/templates instead
     * Get templates for a DocuSign account
     * @deprecated
     */
    async accountsControllerGetAccountTemplatesRaw(requestParameters: AccountsControllerGetAccountTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountTemplates>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling accountsControllerGetAccountTemplates().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling accountsControllerGetAccountTemplates().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling accountsControllerGetAccountTemplates().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling accountsControllerGetAccountTemplates().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling accountsControllerGetAccountTemplates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/accounts/{id}/templates`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountTemplatesFromJSON(jsonValue));
    }

    /**
     * Deprecated: Use GET /accounts/templates instead
     * Get templates for a DocuSign account
     * @deprecated
     */
    async accountsControllerGetAccountTemplates(requestParameters: AccountsControllerGetAccountTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountTemplates> {
        const response = await this.accountsControllerGetAccountTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deprecated: Use GET /accounts/templates instead
     * Get DocuSign accounts for a country
     * @deprecated
     */
    async accountsControllerGetAccountsRaw(requestParameters: AccountsControllerGetAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountInfo>>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling accountsControllerGetAccounts().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling accountsControllerGetAccounts().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling accountsControllerGetAccounts().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling accountsControllerGetAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountInfoFromJSON));
    }

    /**
     * Deprecated: Use GET /accounts/templates instead
     * Get DocuSign accounts for a country
     * @deprecated
     */
    async accountsControllerGetAccounts(requestParameters: AccountsControllerGetAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountInfo>> {
        const response = await this.accountsControllerGetAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get templates for a market
     */
    async accountsControllerGetMarketTemplatesRaw(requestParameters: AccountsControllerGetMarketTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountTemplates>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling accountsControllerGetMarketTemplates().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling accountsControllerGetMarketTemplates().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling accountsControllerGetMarketTemplates().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling accountsControllerGetMarketTemplates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/accounts/templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountTemplatesFromJSON(jsonValue));
    }

    /**
     * Get templates for a market
     */
    async accountsControllerGetMarketTemplates(requestParameters: AccountsControllerGetMarketTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountTemplates> {
        const response = await this.accountsControllerGetMarketTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
